import { render, staticRenderFns } from "./FormKasbonDriver.vue?vue&type=template&id=b0a108e4"
import script from "./FormKasbonDriver.vue?vue&type=script&lang=js"
export * from "./FormKasbonDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports